var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vbn"},[_c('img',{staticClass:"imaBox",attrs:{"src":_vm.imgSrc}}),_c('p',{staticClass:"ts"},[_vm._v("开发者账号申请已提交成功，请等待审核")])])}
var staticRenderFns = []

export { render, staticRenderFns }